// Amdin panel React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";
import * as React from "react"
import { useContext } from "react";
import { AuthContext } from "context/AuthContext";

//firestore
import { db } from "../../../firebase"
import { collection, onSnapshot, where, getDocs, query,deleteDoc,doc ,orderBy} from "firebase/firestore";

function Data() {
  const [data, setData] = React.useState([])
  const { currentUser, role } = useContext(AuthContext)
  const [brandName, setBrandName] = React.useState('')
  
  React.useEffect(() => {
    if (role === 'admin') {
      // Create a query to fetch documents ordered by 'createdAt'
      const jobsQuery = query(
        collection(db, "Jobs"),
        orderBy('createdAt', 'desc') // Order by 'createdAt' in descending order
      );

      // Fetch data and set up real-time listener
      const unsubscribe = onSnapshot(jobsQuery, (snapshot) => {
        const saleList = snapshot.docs.map((doc) => ({
          id: doc.id, // Use 'doc.id' instead of 'items.postuid' to get the document ID
          ...doc.data()
        }));
        setData(saleList);
      }, (error) => {
        console.error("Error fetching data: ", error);
      });

      // Cleanup subscription on component unmount
      return () => {
        unsubscribe();
      };
    }
  }, []); // Add role to dependencies if it can change



  const SR_NO = ({ srNo }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography variant="body2" fontWeight="small">
          {srNo}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
  const SALE_NAME = ({ name, image }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
    <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
    </MDBox>

  );
  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "Jobs", id)); // Delete document using the document ID
      alert("Job deleted successfully!");
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };
  const handleCopyToClipboard = (title, about, link) => {
    const message = `${title}\n\n${about}\n\n${link}`;
    
    // Use the Clipboard API to copy the message to the clipboard
    navigator.clipboard.writeText(message)
      .then(() => {
        //alert('Message copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };
  
  return {
    columns: [
      { Header: "SR NO#", accessor: "srNo", width: "10%", align: "left" },
      { Header: "Name", accessor: "jobTitle", align: "left" },
      { Header: "Action", accessor: "action", align: "right" },
    ],
    rows: [...data.map((items, index) => {
      return ({
        srNo: <SR_NO srNo={items.postuid} />,
        jobTitle: <SALE_NAME image={items.backimg} name={items.Htitle} />,
        action: (
          <>
          <MDButton
            variant="gradient"
            color="error"
            size="small"
            onClick={() => handleDelete(items.postuid)} // Call handleDelete with the document ID
          >
            Delete
          </MDButton>
             <MDButton
             variant="gradient"
             color="info"
             size="small"
             onClick={() => handleCopyToClipboard(items.Htitle, items.About, "https://t.me/fekra_arabia")} // Call handleShare with the data
           >
             Share
           </MDButton>
           </>
        ),
            })
    })]
  }
}
export default Data